import styles from "./styles.module.scss";
import React from 'react';

/**
 * @typedef {Object} Option
 * @property {number|string} value - Option value
 * @property {string} label - Option label text
 */

/**
 * Radio button group component
 * @param {Object} props
 * @param {Array<Option>} props.options - Array of radio options
 * @param {string} props.name - Input name for radio group
 * @param {number|string} props.value - Currently selected value
 * @param {(value: number|string) => void} props.onChange - Change handler
 * @param {string} props.label - Label text for the group
 */
function CheckerGroup({ options, name, value, onChange, label }) {
    return (
        <div className={styles.checkGroup}>
            <span>{label}</span>
            <div className={styles.radioGroup}>
                {options.map((item) => (
                    <label
                        key={item.value}
                        className={`
                            ${styles.radioLabel}
                            ${value === item.value ? "-active" : ""}
                        `}
                    >
                        <input
                            type="radio"
                            name={name}
                            value={item.value}
                            checked={value === item.value}
                            onChange={(e) => {
                                onChange(parseInt(e.target.value));
                            }}
                        />
                        <div className={styles.radioMark} />
                        {item.label}
                    </label>
                ))}
            </div>
        </div>
    );
}

export default CheckerGroup;
